<template>
  <Widget class="fill-height">
    <v-card class="pa-5 fill-height" style="border-radius: 6px" flat>
      <h2 class="text-left mt-3 mb-3">Countries with flagged suppliers</h2>
      <v-row class="fill-height align-center justify-center">
        <v-col xl="9" xxl="7">
          <PMap
            :countries="statsStore.flagging.countryCodes"
            :key="counter"
          ></PMap>
        </v-col>
      </v-row>
    </v-card>
  </Widget>
</template>

<script setup lang="ts">
import { useStatsStore } from "@/stores/statsStore";
import PMap from "@/components/widgets/PMap.vue";
import Widget from "@/views/dashboard-view/Widget.vue";
import { watch } from "vue";

const statsStore = useStatsStore();
let counter = 0;

watch(
  () => statsStore.flagging.countryCodes,
  () => {
    counter += 1;
  }
);
</script>
